import { render, staticRenderFns } from "./DynamicApi.vue?vue&type=template&id=816c2ffc&scoped=true"
import script from "./DynamicApi.vue?vue&type=script&lang=js"
export * from "./DynamicApi.vue?vue&type=script&lang=js"
import style0 from "./DynamicApi.vue?vue&type=style&index=0&id=816c2ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816c2ffc",
  null
  
)

export default component.exports